var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topic-deck"},_vm._l((_vm.topics),function(topic,index){return _c('TopicCard',{key:index,staticClass:"topic-card-fixed",attrs:{"index":index,"title":topic.title,"image":topic.image,"description":topic.description}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }